module.exports = __webpack_public_path__ + "static/media/rl-trader.7a7759f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/rl-trader.jpg
// module id = 229
// module chunks = 2